const unicodeCharAt = (string, index) => {
  const first = string.charCodeAt(index);
  let second;
  if (first >= 0xD800 && first <= 0xDBFF && string.length > index + 1) {
    second = string.charCodeAt(index + 1);
    if (second >= 0xDC00 && second <= 0xDFFF) {
      return string.substring(index, index + 2);
    }
  }
  return string[index];
};

const unicodeSlice = (string, start, end) => {
  let accumulator = '';
  let character;
  let stringIndex = 0;
  let unicodeIndex = 0;
  const length = string.length;

  while (stringIndex < length) {
    character = unicodeCharAt(string, stringIndex);
    if (unicodeIndex >= start && unicodeIndex < end) {
      accumulator += character;
    }
    stringIndex += character.length;
    unicodeIndex += 1;
  }
  return accumulator;
};

// Defining Colors
const colors = [
  '#1abc9c', '#16a085', '#f1c40f', '#f39c12', '#2ecc71', '#27ae60', '#e67e22',
  '#d35400', '#3498db', '#2980b9', '#e74c3c', '#c0392b', '#9b59b6', '#8e44ad',
  '#bdc3c7', '#34495e', '#2c3e50', '#95a5a6', '#7f8c8d', '#ec87bf', '#d870ad',
  '#f69785', '#9ba37e', '#b49255', '#b49255', '#a94136',
];
let finalColor;

const make = function make(options) {
  const settings = $.extend({
    // Default settings
    name: 'Name',
    color: null,
    seed: 0,
    charCount: 1,
    textColor: '#ffffff',
    height: 100,
    width: 100,
    fontSize: options.fontSize || ((options.height || 100) * 0.6),
    fontWeight: 400,
    fontFamily: 'HelveticaNeue-Light,Helvetica Neue Light,Helvetica Neue,Helvetica, Arial,Lucida Grande, sans-serif',
    radius: 0,
  }, options);

  // making the text object
  const c = unicodeSlice(settings.name, 0, settings.charCount).toUpperCase();
  const cobj = $('<text text-anchor="middle"></text>')
    .attr({
      'y': '50%',
      'x': '50%',
      'dy': '0.35em',
      'pointer-events': 'auto',
      'fill': settings.textColor,
      'font-family': settings.fontFamily,
    })
    .html(c)
    .css({
      'font-weight': settings.fontWeight,
      'font-size': settings.fontSize+'px',
    });

  if (settings.color == null) {
    const colorIndex = Math.floor((c.charCodeAt(0) + settings.seed) % colors.length);
    finalColor = colors[colorIndex];
  } else {
    finalColor = settings.color;
  }

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  Object.entries({
    'xmlns': 'http://www.w3.org/2000/svg',
    'pointer-events': 'none',
    'viewBox': `0 0 ${settings.width} ${settings.height}`,
  }).forEach(([k, v]) => { svg.setAttribute(k, v); });

  Object.entries({
    'background-color': finalColor,
  }).forEach(([k, v]) => { svg.style[k] = v; });

  svg.appendChild(cobj[0]);

  const svgHtml = window
    .btoa(
      unescape(
        encodeURIComponent(
          svg.outerHTML,
        ),
      ),
    );

  return 'data:image/svg+xml;base64,' + svgHtml;
};

export default {
  make,
};
